"use strict";


/**
 *	Vars
 */

	let lastScrollPosition,
		mediaQueries = {
			"30em": "s",
			"48em": "m",
			"64em": "l",
			"80em": "xl",
			"90em": "xxl",
			"120em": "xxxl"
		};


/**
 *	Get document size
 */

	export function getDocumentSize() {
		return document.documentElement.getBoundingClientRect();
	}


/**
 *	Get window size
 */

	export function getWindowSize() {
		return {
			width: window.innerWidth,
			height: window.innerHeight
		}
	}


/**
 *	Get media query
 */

	export function getMediaQuery() {
		let mediaQuery;
		
		for ( let i in mediaQueries ) {
			if ( window.matchMedia && window.matchMedia("screen and (min-width: " + i + ")").matches ) {
				mediaQuery = parseInt( i );
			}
		}

		if ( mediaQuery == null ) {
			mediaQuery = 0;
		}

		return mediaQuery;
	}


/**
 *	Get orientation
 */

	export function getOrientation() {
		let orientation = "portrait";

		if ( window.matchMedia("(orientation: landscape)").matches ) {
			orientation = "landscape";
		}

		return orientation;
	}


/**
 *	Get size
 */

	export function getSize() {
		let mediaQuery = `${getMediaQuery()}em`;

		return ( parseInt(mediaQuery) === 0 ) ? "xs" : mediaQueries[mediaQuery];
	}


/**
 *	Get scroll top
 */

	export function getScrollTop( node ) {
		let top = ( !node ) ? window.pageYOffset : node.scrollTop;

		return ( top < 0 ) ? 0 : top;
	}


/**
 *	Get scroll bottom
 */

	export function getScrollBottom( node, content ) {
		let height = ( !content ) ? getDocumentSize().height : content.offsetHeight,
			bottom = ( height - getWindowSize().height ) - getScrollTop( node );

		return ( bottom < 0 ) ? 0 : bottom;
	}


/**
 *	Get scroll perc
 */

	export function getScrollPerc( node, content ) {
		let height = ( !content ) ? getDocumentSize().height : content.offsetHeight;

		return getScrollTop( node ) / ( height - getWindowSize().height );
	}


/**
 *	Get scroll direction
 */

	export function getScrollDirection( node ) {
		let direction = ( getScrollTop( node ) > lastScrollPosition ) ? "down" : "up";

		lastScrollPosition = getScrollTop( node );

		return direction;
	}


/**
 *	Log
 */

	export function log( log ) {
		console.log( log );
	}